import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getMoreProfile, UpdateMoreProfile } from "../api/api";
import "../UpdateProfileDetails/UpdateUploadProfileDetails.css";
import { useNavigate } from "react-router-dom";

const options = {
  relationship_status: [
    "Divorced",
    "Domestic Partnership",
    "Separated",
    "Single",
    "Unknown/Prefer Not to Say",
    "Widowed",
    "Other",
    "Prefer not to say",
  ],
  ethnicity: [
    "Asian",
    "Black",
    "Caucasian",
    "Hispanic",
    "Other",
    "Prefer not to say",
  ],
  religion: ["Christianity", "Islam", "Other", "Prefer not to say"],
  occupation: [
    "Accountant",
    "Actor",
    "Administrative Assistant",
    "Architect",
    "Artist",
    "Business Owner",
    "Chef",
    "Consultant",
    "Designer",
    "Doctor",
    "Engineer",
    "Entrepreneur",
    "Finance Professional",
    "Firefighter",
    "Freelancer",
    "Homemaker",
    "Lawyer",
    "Marketing Specialist",
    "Mechanic",
    "Military Personnel",
    "Musician",
    "Nurse",
    "Pharmacist",
    "Police Officer",
    "Real Estate Agent",
    "Retired",
    "Salesperson",
    "Scientist",
    "Software Developer",
    "Student",
    "Teacher",
    "Unemployed",
    "Writer",
    "Other",
    "Prefer not to say",
  ],
  blood_group: [
    "AA (Normal)",
    "AS (Carrier)",
    "SS (Sickle Cell Disease)",
    "Other",
    "Prefer not to say",
  ],
  have_children: ["Yes", "No"],
  want_children: ["Yes", "No"],
  height: [
    "< 150 cm",
    "150 - 155 cm",
    "156 - 160 cm",
    "161 - 165 cm",
    "166 - 170 cm",
    "171 - 175 cm",
    "176 - 180 cm",
    "181 - 185 cm",
    "186 - 190 cm",
    "> 190 cm",
    "Any",
  ],
  body_type: [
    "Athletic",
    "Average",
    "Curvy",
    "Slim",
    "Other",
    "Prefer not to say",
  ],
  hair_color: ["Black", "Blonde", "Brown", "Other", "Prefer not to say"],
  language_spoken: [
    "Arabic",
    "Bengali",
    "English",
    "French",
    "German",
    "Gujarati",
    "Hindi",
    "Italian",
    "Japanese",
    "Javanese",
    "Korean",
    "Malay/Indonesian",
    "Mandarin Chinese",
    "Marathi",
    "Persian (Farsi)",
    "Portuguese",
    "Punjabi",
    "Russian",
    "Spanish",
    "Swahili",
    "Tamil",
    "Telugu",
    "Turkish",
    "Urdu",
    "Vietnamese",
    "Other",
    "Prefer not to say",
  ],
  political_affiliation: [
    "Conservative",
    "Liberal",
    "Moderate",
    "Other",
    "Prefer not to say",
  ],
  smokes: ["Yes", "No"],
  drinks: ["Yes", "No"],
  have_pets: ["Yes", "No"],
  have_pet_allergies: ["Yes", "No"],
  preferred_game_genere: [
    "Action",
    "Adventure",
    "Arcade",
    "Battle Royale",
    "Card & Board",
    "Casual",
    "Fighting",
    "Idle / Clicker",
    "Multiplayer",
    "Platformer",
    "Puzzle",
    "Racing",
    "Role-Playing (RPG)",
    "Shooter",
    "Simulation",
    "Sports",
    "Strategy",
    "Survival",
    "Trivia / Quiz",
    "Other",
    "Prefer not to say",
  ],
  education_level: [
    "High School",
    "Bachelor's",
    "Master's",
    "PhD",
    "Other",
    "Prefer not to say",
  ],
  cultural_background: [
    "Asian",
    "African",
    "European",
    "Indigenous",
    "Other",
    "Prefer not to say",
  ],
  // income removed here
};
const multiSelectFields = ["language_spoken", "preferred_game_genere"];

const validationSchema = Yup.object({
  ...Object.fromEntries(
    Object.keys(options).map((key) => {
      const isMulti =
        key === "language_spoken" || key === "preferred_game_genere";
      return [
        key,
        isMulti
          ? Yup.array()
              .min(1, "Select at least one option")
              .max(5)
              .required("Required")
          : Yup.string().required("Required"),
      ];
    })
  ),
  // income: Yup.string().required("Income is required"),
});

const getUserId = () => {
  const userStr = localStorage.getItem("currentUser");
  const user = JSON.parse(userStr);
  return user?.id || user?._id;
};

const UpdateuploadProfileDetails = () => {
  const defaultValues = {
    ...Object.fromEntries(
      Object.keys(options).map((key) => [
        key,
        key === "language_spoken" || key === "preferred_game_genere" ? [] : "",
      ])
    ),
    // income: "",
  };

  const [initialValues, setInitialValues] = useState(defaultValues);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const id = getUserId();
        const res = await getMoreProfile({ user_id: id });
        const data = res?.data || {};

        const formatted = {};
        Object.keys(options).forEach((key) => {
          formatted[key] =
            key === "language_spoken" || key === "preferred_game_genere"
              ? Array.isArray(data[key])
                ? data[key]
                : []
              : data[key] || "";
        });
        // formatted.income = data.income || "";

        setInitialValues(formatted);
      } catch (err) {
        console.error("Error loading profile:", err);
      }
    };

    fetchProfile();
  }, []);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const id = getUserId();
        const payload = {
          user_id: id,
          profile_completion_status: "Tab",
          ...values,
        };
        await UpdateMoreProfile(payload);
        navigate("/Sidebar/EditProfile");
      } catch (err) {
        console.error("Update error:", err);
      } finally {
        setLoading(false);
      }
    },
  });

  //   return (
  //     <form onSubmit={formik.handleSubmit} className="profile-form-container">
  //       <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>Update Profile Details</h2>

  //       {Object.entries(options).map(([key, values]) => (
  //         <div key={key} className="form-group">
  //           <label htmlFor={key}>{key.replace(/_/g, ' ')}</label>
  //           {Array.isArray(formik.values[key]) ? (
  //             <select
  //               multiple
  //               name={key}
  //               id={key}
  //               value={formik.values[key]}
  //               onBlur={() => formik.setFieldTouched(key, true)}
  //               onChange={e =>
  //                 formik.setFieldValue(
  //                   key,
  //                   Array.from(e.target.selectedOptions, opt => opt.value)
  //                 )
  //               }
  //             >
  //               {values.map(opt => (
  //                 <option key={opt} value={opt}>
  //                   {opt}
  //                 </option>
  //               ))}
  //             </select>
  //           ) : (
  //             <select
  //               name={key}
  //               id={key}
  //               value={formik.values[key]}
  //               onChange={formik.handleChange}
  //               onBlur={formik.handleBlur}
  //             >
  //               <option value="">Select</option>
  //               {values.map(opt => (
  //                 <option key={opt} value={opt}>
  //                   {opt}
  //                 </option>
  //               ))}
  //             </select>
  //           )}
  //           {formik.touched[key] && formik.errors[key] && (
  //             <div className="error">{formik.errors[key]}</div>
  //           )}
  //         </div>
  //       ))}

  //       {/* Custom income input field */}
  //       <div className="form-group">
  //         <label htmlFor="income">Income</label>
  //         <input
  //           type="text"
  //           name="income"
  //           id="income"
  //           value={formik.values.income}
  //           onChange={formik.handleChange}
  //           onBlur={formik.handleBlur}
  //           placeholder="Enter your income"
  //           style={{ width: '100%', padding: '0.6rem', borderRadius: '4px', border: '1px solid #ccc' }}
  //         />
  //         {formik.touched.income && formik.errors.income && (
  //           <div className="error">{formik.errors.income}</div>
  //         )}
  //       </div>

  //       <div className="button-group">
  //         <button
  //           type="button"
  //           className="btn back"
  //           onClick={() => navigate('/Sidebar/EditProfile', { replace: true })}
  //         >
  //           Back
  //         </button>
  //         <button
  //           type="submit"
  //           className="btn submit"
  //           disabled={loading}
  //         >
  //           {loading ? 'Saving...' : 'Save Profile'}
  //         </button>
  //       </div>
  //     </form>
  //   );

  return (
    <form onSubmit={formik.handleSubmit} className="profile-form-container">
      <h2 style={{ textAlign: "center", marginBottom: "1.5rem" }}>
        Update Profile Details
      </h2>

      {Object.entries(options).map(([key, values]) => (
        <div key={key} className="form-group">
          <label htmlFor={key}>{key.replace(/_/g, " ")}</label>
          {multiSelectFields.includes(key) ? (
            <select
              multiple
              name={key}
              id={key}
              value={formik.values[key]}
              onBlur={() => formik.setFieldTouched(key, true)}
              onChange={(e) =>
                formik.setFieldValue(
                  key,
                  Array.from(e.target.selectedOptions, (opt) => opt.value)
                )
              }
              style={{ minHeight: "100px", padding: "0.5rem" }}
            >
              {values.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          ) : (
            <select
              name={key}
              id={key}
              value={formik.values[key]}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="">Select</option>
              {values.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          )}
          {formik.touched[key] && formik.errors[key] && (
            <div className="error">{formik.errors[key]}</div>
          )}
        </div>
      ))}

      {/* Income field */}
      {/* <div className="form-group">
        <label htmlFor="income">Income</label>
        <input
          type="text"
          name="income"
          id="income"
          value={formik.values.income}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Enter your income"
          style={{
            width: "100%",
            padding: "0.6rem",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
        {formik.touched.income && formik.errors.income && (
          <div className="error">{formik.errors.income}</div>
        )}
      </div> */}

      <div className="button-group">
        <button
          type="button"
          className="btn back"
          onClick={() => navigate("/Sidebar/EditProfile", { replace: true })}
        >
          Back
        </button>
        <button type="submit" className="btn submit" disabled={loading}>
          {loading ? "Saving..." : "Save Profile"}
        </button>
      </div>
    </form>
  );
};

export default UpdateuploadProfileDetails;
